angular.module("ngSentry", []);
Sentry.init({
  dsn: "https://4841a7643ef643c0b5731b7a7ce45b2c@o133707.ingest.sentry.io/6169248",
  integrations: [new Sentry.Integrations.Angular()],
  tracesSampleRate: 1.0,
});
